export default "__VITE_PUBLIC_ASSET__44bcf543__"